import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const FAVORITES_COOKIE_KEY = 'zerde_favorites';

interface FavoriteArticle {
  id: string;
  categoryId: string;
  subcategoryId: string;
  title: string;
}

export const useFavorites = () => {
  const [favorites, setFavorites] = useState<FavoriteArticle[]>([]);

  // Загрузка избранного из куки при инициализации
  useEffect(() => {
    const savedFavorites = Cookies.get(FAVORITES_COOKIE_KEY);
    if (savedFavorites) {
      try {
        setFavorites(JSON.parse(savedFavorites));
      } catch (e) {
        console.error('Error parsing favorites:', e);
        setFavorites([]);
      }
    }
  }, []);

  // Сохранение в куки при изменении избранного
  const saveFavorites = (newFavorites: FavoriteArticle[]) => {
    Cookies.set(FAVORITES_COOKIE_KEY, JSON.stringify(newFavorites), { expires: 365 });
    setFavorites(newFavorites);
  };

  const addToFavorites = (article: FavoriteArticle) => {
    if (!favorites.some(fav => fav.id === article.id)) {
      saveFavorites([...favorites, article]);
    }
  };

  const removeFromFavorites = (articleId: string) => {
    saveFavorites(favorites.filter(fav => fav.id !== articleId));
  };

  const isFavorite = (articleId: string) => {
    return favorites.some(fav => fav.id === articleId);
  };

  return {
    favorites,
    addToFavorites,
    removeFromFavorites,
    isFavorite,
  };
}; 